import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Navigation from 'flarum/common/components/Navigation';
export default function modifyNavigation() {
  function checkRoute() {
    var _app$current;
    // 2026-07-31 v0.4.7.1 (Mavis 紧急修): 适配 Flarum 2.0
    //   1.8 时代 app.current 是 mithril Stream 走 .get('routeName')
    //   2.0 改 PageState 实例, routeName 在 app.current.data.routeName
    //   app.current 在路由切换瞬间可能为 null, 加 ?. + String() 防 .replace throw
    //   修前症状: 移动端 /dressUp 等路由渲染时 200+ console error, AvatarModal 没法挂载
    //   (Trello #393 后续, 修 ziven-dress-up mobile 端不能添加形象)
    // 2026-08-26 v0.5.4 (辉哥 8:23 反馈): 删 $(".AppNavigationSearchIcon") 引用 + routeClassName
    //   dead code (vendor Flarum 2.0 Navigation mount 模式变了, 搜索按钮元素永远不会创建,
    //   oncreate 整段已经删了, jQuery 操作 empty selector no-op 留着也只会让人 confusion)
    const routeName = String(((_app$current = app.current) == null || (_app$current = _app$current.data) == null ? void 0 : _app$current.routeName) || '');
    const excludeList = ["notifications", "search"];
    const isLoading = $("#app").find(".LoadingIndicator-container").length > 0;
    const isPreloaded = $("#app").find(".App-titleControl").length > 0;
    if (excludeList.indexOf(routeName) !== -1 || isLoading === true && isPreloaded === false) {
      $(".AppNavigationContainer").hide();
    } else {
      $(".AppNavigationContainer").show();
    }
  }
  extend(Navigation.prototype, 'onupdate', function (vnode) {
    checkRoute();
  });
}